import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af89e1c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridRow" }
const _hoisted_2 = {
  key: 0,
  class: "gridRow"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "gridRow" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "gridRow" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "gridRow" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "gridRow" }
const _hoisted_11 = {
  key: 1,
  class: "gridTemplateRow"
}
const _hoisted_12 = { class: "gridTemplateLabel" }
const _hoisted_13 = { class: "gridRow" }
const _hoisted_14 = { class: "gridRow" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "gridRow" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { class: "gridRow" }
const _hoisted_20 = {
  key: 0,
  class: "itemSeparator"
}
const _hoisted_21 = {
  key: 0,
  class: "buttonRow"
}
const _hoisted_22 = { class: "gridRow" }
const _hoisted_23 = {
  key: 0,
  class: "itemSeparator"
}
const _hoisted_24 = {
  key: 0,
  class: "buttonRow"
}
const _hoisted_25 = { class: "gridRow" }
const _hoisted_26 = {
  key: 2,
  class: "gridRow"
}
const _hoisted_27 = { class: "gridRow" }
const _hoisted_28 = { class: "gridRow" }
const _hoisted_29 = {
  key: 0,
  class: "itemSeparator"
}
const _hoisted_30 = {
  key: 0,
  class: "buttonRow"
}
const _hoisted_31 = { class: "gridRow" }
const _hoisted_32 = {
  key: 3,
  class: "buttonRow"
}
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationErrors = _resolveComponent("ValidationErrors")!
  const _component_FormBoolean = _resolveComponent("FormBoolean")!
  const _component_FormDropdown = _resolveComponent("FormDropdown")!
  const _component_FormTextBox = _resolveComponent("FormTextBox")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ValidationErrors, { errors: _ctx.validationErrors }, null, 8, ["errors"]),
    _createVNode(_component_Form, {
      "validation-schema": _ctx.validationSchema,
      onSubmit: _ctx.handleSubmit,
      onInvalidSubmit: _ctx.handleInvalid
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_FormBoolean, {
            name: "isUnion",
            modelValue: _ctx.preScreen.isUnion,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preScreen.isUnion) = $event)),
            langKey: "isUnion",
            required: true,
            disabled: _ctx.disabled
          }, null, 8, ["modelValue", "disabled"])
        ]),
        (_ctx.preScreen.isUnion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_FormDropdown, {
                name: "unionName",
                modelValue: _ctx.preScreen.unionName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.preScreen.unionName) = $event)),
                langKey: "unionName",
                options: _ctx.unionOptions,
                required: true,
                disabled: _ctx.disabled
              }, null, 8, ["modelValue", "options", "disabled"]),
              (_ctx.preScreen.unionName == 'Other')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_FormTextBox, {
                      name: "unionOther",
                      modelValue: _ctx.preScreen.unionOther,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.preScreen.unionOther) = $event)),
                      langKey: "specify",
                      required: true,
                      disabled: _ctx.disabled
                    }, null, 8, ["modelValue", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_FormTextBox, {
                name: "unionLocal",
                modelValue: _ctx.preScreen.unionLocal,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.preScreen.unionLocal) = $event)),
                langKey: "unionLocal",
                required: true,
                disabled: _ctx.disabled
              }, null, 8, ["modelValue", "disabled"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FormDropdown, {
            name: "source",
            modelValue: _ctx.preScreen.source,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.preScreen.source) = $event)),
            langKey: "source",
            options: _ctx.sourceOptions,
            required: true,
            disabled: _ctx.disabled
          }, null, 8, ["modelValue", "options", "disabled"]),
          (_ctx.preScreen.source == 'Other')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_FormTextBox, {
                  name: "sourceOther",
                  modelValue: _ctx.preScreen.sourceOther,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.preScreen.sourceOther) = $event)),
                  langKey: "specify",
                  required: true,
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FormBoolean, {
            name: "hasChildcare",
            modelValue: _ctx.preScreen.hasChildcare,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.preScreen.hasChildcare) = $event)),
            langKey: "hasChildcare",
            required: true,
            disabled: _ctx.disabled,
            "has-tooltip": true
          }, null, 8, ["modelValue", "disabled"]),
          (_ctx.preScreen.hasChildcare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_FormBoolean, {
                  name: "isLicensedProvider",
                  modelValue: _ctx.preScreen.isLicensedProvider,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.preScreen.isLicensedProvider) = $event)),
                  langKey: "isLicensedProvider",
                  required: true,
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_FormBoolean, {
            name: "hasOtherAdults",
            modelValue: _ctx.preScreen.hasOtherAdults,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.preScreen.hasOtherAdults) = $event)),
            langKey: "hasOtherAdults",
            required: true,
            disabled: _ctx.disabled
          }, null, 8, ["modelValue", "disabled"]),
          (_ctx.preScreen.hasOtherAdults)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_FormBoolean, {
                  name: "hasRelationship",
                  modelValue: _ctx.preScreen.hasRelationship,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.preScreen.hasRelationship) = $event)),
                  langKey: "hasRelationship",
                  required: true,
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_FormTextBox, {
            name: "numChildren",
            modelValue: _ctx.preScreen.numChildren,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.preScreen.numChildren) = $event)),
            type: "number",
            langKey: "numChildren",
            required: true,
            disabled: _ctx.disabled
          }, null, 8, ["modelValue", "disabled"])
        ]),
        (_ctx.preScreen.numChildren && _ctx.preScreen.numChildren > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t('childrenAges')), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preScreen.children, (c, index) => {
                return (_openBlock(), _createBlock(_component_FormDropdown, {
                  key: index,
                  name: `children[${index}].age`,
                  modelValue: c.age,
                  "onUpdate:modelValue": ($event: any) => ((c.age) = $event),
                  langKey: "child",
                  options: _ctx.ageOptions,
                  required: true,
                  index: index,
                  disabled: _ctx.disabled
                }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "options", "index", "disabled"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_FormTextBox, {
            name: "numChildcare",
            modelValue: _ctx.preScreen.numChildcare,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.preScreen.numChildcare) = $event)),
            type: "number",
            langKey: "numChildcare",
            required: true,
            disabled: _ctx.disabled
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_FormBoolean, {
            name: "hasOtherParents",
            modelValue: _ctx.preScreen.hasOtherParents,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.preScreen.hasOtherParents) = $event)),
            langKey: "hasOtherParents",
            required: true,
            disabled: _ctx.disabled
          }, null, 8, ["modelValue", "disabled"]),
          (_ctx.preScreen.hasOtherParents)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_FormTextBox, {
                  name: "numParentOutside",
                  modelValue: _ctx.preScreen.numParentOutside,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.preScreen.numParentOutside) = $event)),
                  type: "number",
                  langKey: "numParentOutside",
                  required: true,
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_FormBoolean, {
            name: "isWorking",
            modelValue: _ctx.preScreen.isWorking,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.preScreen.isWorking) = $event)),
            langKey: _ctx.hasOtherAdultIncome ? 'isWorkingPlural' : 'isWorking',
            required: true,
            disabled: _ctx.disabled
          }, null, 8, ["modelValue", "langKey", "disabled"]),
          (_ctx.preScreen.isWorking)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_FormBoolean, {
                  name: "hoursPerWeek",
                  modelValue: _ctx.preScreen.hoursPerWeek,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.preScreen.hoursPerWeek) = $event)),
                  langKey: _ctx.hasOtherAdultIncome ? 'hoursPerWeekPlural' : 'hoursPerWeek',
                  required: true,
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "langKey", "disabled"]),
                (_ctx.preScreen.hoursPerWeek===false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_FormBoolean, {
                        name: "proofOfEmployment",
                        modelValue: _ctx.preScreen.proofOfEmployment,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.preScreen.proofOfEmployment) = $event)),
                        langKey: _ctx.hasOtherAdultIncome ? 'proofOfEmploymentPlural': 'proofOfEmployment',
                        required: true,
                        disabled: _ctx.disabled
                      }, null, 8, ["modelValue", "langKey", "disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isEligibleWork)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_18,
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('steps.incomeInformation', {num: '2a'})), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preScreen.jobs, (job, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_FormDropdown, {
                      name: `jobs[${index}].frequency`,
                      modelValue: job.frequency,
                      "onUpdate:modelValue": ($event: any) => ((job.frequency) = $event),
                      langKey: "frequency",
                      options: _ctx.frequencies,
                      required: true,
                      disabled: _ctx.disabled
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "options", "disabled"]),
                    _createVNode(_component_FormTextBox, {
                      name: `jobs[${index}].amount`,
                      modelValue: job.amount,
                      "onUpdate:modelValue": ($event: any) => ((job.amount) = $event),
                      type: "currency",
                      langKey: "payPerPaycheck",
                      required: true,
                      disabled: _ctx.disabled
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled"])
                  ]),
                  (index < _ctx.preScreen.jobs.length - 1)
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_20))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (!_ctx.disabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "button",
                      onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addJob && _ctx.addJob(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('buttons.addJob')), 1),
                    (_ctx.preScreen.jobs.length > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "button",
                          onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeJob && _ctx.removeJob(...args)), ["prevent"]))
                        }, _toDisplayString(_ctx.$t('buttons.removeJob')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasOtherAdultIncome)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preScreen.otherAdultJobs, (otherJob, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_FormDropdown, {
                            name: `otherAdultJobs[${index}].frequency`,
                            modelValue: otherJob.frequency,
                            "onUpdate:modelValue": ($event: any) => ((otherJob.frequency) = $event),
                            langKey: "otherPayFrequency",
                            options: _ctx.frequencies,
                            required: true,
                            disabled: _ctx.disabled
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "options", "disabled"]),
                          _createVNode(_component_FormTextBox, {
                            name: `otherAdultJobs[${index}].amount`,
                            modelValue: otherJob.amount,
                            "onUpdate:modelValue": ($event: any) => ((otherJob.amount) = $event),
                            type: "currency",
                            langKey: "otherPayPerPaycheck",
                            required: true,
                            disabled: _ctx.disabled
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        (index < _ctx.preScreen.otherAdultJobs.length - 1)
                          ? (_openBlock(), _createElementBlock("hr", _hoisted_23))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("button", {
                            class: "button",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addOtherJob && _ctx.addOtherJob(...args)), ["prevent"]))
                          }, _toDisplayString(_ctx.$t('buttons.addJob')), 1),
                          (_ctx.preScreen.otherAdultJobs.length > 1)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button",
                                onClick: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeOtherJob && _ctx.removeOtherJob(...args)), ["prevent"]))
                              }, _toDisplayString(_ctx.$t('buttons.removeJob')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_FormBoolean, {
                  name: "hasChildSupport",
                  modelValue: _ctx.preScreen.hasChildSupport,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.preScreen.hasChildSupport) = $event)),
                  langKey: _ctx.hasOtherAdultIncome ? 'hasChildSupportPlural' : 'hasChildSupport',
                  required: true,
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "langKey", "disabled"])
              ]),
              (_ctx.preScreen.hasChildSupport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_component_FormDropdown, {
                      name: "childSupportFrequency",
                      modelValue: _ctx.preScreen.childSupportFrequency,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.preScreen.childSupportFrequency) = $event)),
                      langKey: "childSupportFrequency",
                      options: _ctx.frequencies,
                      required: true,
                      disabled: _ctx.disabled
                    }, null, 8, ["modelValue", "options", "disabled"]),
                    _createVNode(_component_FormTextBox, {
                      name: "childSupportAmount",
                      modelValue: _ctx.preScreen.childSupportAmount,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.preScreen.childSupportAmount) = $event)),
                      type: "currency",
                      langKey: "childSupportAmount",
                      required: true,
                      disabled: _ctx.disabled
                    }, null, 8, ["modelValue", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_FormBoolean, {
                  name: "hasOtherIncome",
                  modelValue: _ctx.preScreen.hasOtherIncome,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.preScreen.hasOtherIncome) = $event)),
                  langKey: _ctx.hasOtherAdultIncome ? 'hasOtherIncomePlural' : 'hasOtherIncome',
                  required: true,
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "langKey", "disabled"])
              ]),
              (_ctx.preScreen.hasOtherIncome)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preScreen.otherIncome, (income, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_FormDropdown, {
                            name: `otherIncome[${index}].type`,
                            modelValue: income.type,
                            "onUpdate:modelValue": ($event: any) => ((income.type) = $event),
                            langKey: "otherIncomeType",
                            options: _ctx.otherIncomeOptions,
                            required: true,
                            cssClass: "colOneThird",
                            disabled: _ctx.disabled
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "options", "disabled"]),
                          _createVNode(_component_FormDropdown, {
                            name: `otherIncome[${index}].frequency`,
                            modelValue: income.frequency,
                            "onUpdate:modelValue": ($event: any) => ((income.frequency) = $event),
                            langKey: "frequency",
                            options: _ctx.frequencies,
                            required: true,
                            disabled: _ctx.disabled
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "options", "disabled"]),
                          _createVNode(_component_FormTextBox, {
                            name: `otherIncome[${index}].amount`,
                            modelValue: income.amount,
                            "onUpdate:modelValue": ($event: any) => ((income.amount) = $event),
                            type: "currency",
                            langKey: "otherIncomeAmount",
                            required: true,
                            disabled: _ctx.disabled
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        (index < _ctx.preScreen.otherIncome.length - 1)
                          ? (_openBlock(), _createElementBlock("hr", _hoisted_29))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("button", {
                            class: "button",
                            onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addOtherIncome && _ctx.addOtherIncome(...args)), ["prevent"]))
                          }, _toDisplayString(_ctx.$t('buttons.addOtherIncome')), 1),
                          (_ctx.preScreen.otherIncome.length > 1)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button",
                                onClick: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeOtherIncome && _ctx.removeOtherIncome(...args)), ["prevent"]))
                              }, _toDisplayString(_ctx.$t('buttons.removeOtherIncome')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_FormTextBox, {
                  name: "otherInformation",
                  modelValue: _ctx.preScreen.otherInformation,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.preScreen.otherInformation) = $event)),
                  type: "textarea",
                  langKey: "additionalInformation",
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "disabled"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "submit",
                class: "button",
                disabled: _ctx.isSubmitting
              }, _toDisplayString(_ctx.$t('actions.submit')), 9, _hoisted_33)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["validation-schema", "onSubmit", "onInvalidSubmit"])
  ], 64))
}